import { render, staticRenderFns } from "./Arm1000-F.vue?vue&type=template&id=6bd23d3e"
import script from "./Arm1000-F.vue?vue&type=script&lang=js"
export * from "./Arm1000-F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports